package com.karawek.core.auth.stytch.config

data class StytchConfig(
    val publicToken: String,
    val tokenExpirationMinutes: Int,
    val sessionDurationMinutes: Int,
    val googleClientId: String,
    val applicationId: String,
    val oauthCallbackPort: Int = 7878,
    val passkeyDomain: String = "",
)
